import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;

  .file-preview-frame {
    flex: 1;
    width: 100%;
    min-height: 320px;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 6px;
  }

  .file-preview-image {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  .file-preview-image img {
    max-height: 100%;
    object-fit: contain;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 6px;
  }

  .file-preview-empty {
    background: ${(props) => props.theme.$gray100};
    border-radius: 6px;
  }
`;
